"use client";

import Card from '@mui/material/Card'
import React from 'react'
import CardContent from "@mui/material/CardContent";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Link from '@mui/material/Link';
interface CardContributeProps {
    title: string;
    description: string;
    action: string;
    icon: any;
    link?: string;
}

const CardContribute = ({ title, description, action, icon, link }: CardContributeProps) => {
    const theme = useTheme();
    const card = (
        <CardContent sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
        }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
            }}>
                {icon}
                <Typography
                    sx={{
                        fontFamily: 'Roboto',
                        fontSize: '18px',
                        fontWeight: 700,
                        marginLeft: '8px',
                        lineHeight: '24px',
                        color: theme.palette.grey[800]
                    }}>
                    {title}
                </Typography>
            </Box>
            <Typography
                component="div"
                sx={{
                    fontWeight: 400,
                    marginTop: '20px',
                    fontSize: '18px',
                }}>
                {description}
            </Typography>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <Typography
                    component="div"
                    sx={{
                        fontWeight: 700,
                        marginTop: '20px',
                        fontSize: '18px',
                        color: theme.palette.grey[800]
                    }}>
                    {link ? (
                        <Link
                            href={link}
                            sx={{
                                textDecoration: 'none',
                                color: 'inherit'
                            }}
                        >
                            {action}
                        </Link>
                    ) : (
                        action
                    )}
                </Typography>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '8px',
                    marginTop: '20px'
                }}>
                    <Link href={link}>
                        <ArrowCircleRightOutlinedIcon sx={{ fontSize: "3rem", color: theme.palette.grey[800] }} />
                    </Link>
                </Box>
            </Box>
        </CardContent>
    )
    return (
        <Card sx={{
            backgroundColor: theme.palette.background.default,
            flex: 1,
            border: "1px solid",
            borderColor: theme.palette.success.contrastText,
            borderRadius: "2px"
        }}>
            {card}
        </Card>
    )
}
export default CardContribute